import * as Validator from './ValidatorContext';

export { validator } from './rules';
export type { Rules } from './rules';

export default Validator;
